
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		value: {
			type: String,
			required: true
		},
		knownHeaders: {
			type: Array as ()=>string[],
			required: true
		},
		label: {
			type: [String, Object as ()=>TranslateResult]
		}
	},
	computed: {
		oldHeaderNameItems():string[]{
			return this.knownHeaders.filter(i=>{
				return i.toLowerCase().indexOf(this.value.toLowerCase()) != -1;
			});
		}
	},
	methods: {
		onAutocompleteBlur(){
			if (this.oldHeaderNameItems.length == 1) {
				this.setValue(this.oldHeaderNameItems[0]);
			}
		},
		setValue(value:string){
			this.$emit("input", value);
		}
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
